module.exports = __webpack_public_path__ + "static/media/status_ok.8d63eb9a.svg";